import { createSelector, MemoizedSelector } from '@ngrx/store';

import { getUserState } from '../reducers';
import { UserState } from '../reducers/user.reducer';
import { IUser } from '../..';
import { IInvoiceInfo } from '@cakeiteasy/web-utils';

export const getUser: MemoizedSelector<Object, IUser> = createSelector(
  getUserState,
  (state: UserState) => state.user
);

export const getUserInvoiceInfo: MemoizedSelector<Object, IInvoiceInfo> = createSelector(
  getUserState,
  (state: UserState) => {
    if (state.user) {
      return state.user.invoiceInfo || null;
    }

    return null;
  }
);

export const getUserLoaded: MemoizedSelector<Object, boolean> = createSelector(
  getUserState,
  (state: UserState) => state.loaded
);
export const getUserLoading: MemoizedSelector<Object, boolean> = createSelector(
  getUserState,
  (state: UserState) => state.loading
);
